//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TableCellObject',
  props: {
    col: {
      type: Object,
      required: true
    },
    value: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    isObject: function () {
      return this.value != null && typeof this.value === 'object'
    },
    objectURL: function () {
      if (this.isObject && this.value.id != null) {
        const type = this.value.type || this.col.columnObjectType
        if (type && this.$d_hasObjectCardAccess(type)) {
          return this.$d_getUrlObjectCard(this.value.id, type, this.col.columnObjectSubType || null)
        }
      }
      return null
    },
    name: function () {
      if (this.isObject) {
        if (this.col.columnObjectNameProp) {
          if (Array.isArray(this.col.columnObjectNameProp)) {
            const values = []
            this.col.columnObjectNameProp.forEach(prop => {
              values.push(this.value[prop])
            })
            return values.join(', ')
          } else {
            return this.value[this.col.columnObjectNameProp]
          }
        }
        return this.value.name
      }
      return this.value
    }
  }
}
